/**
 * FlowAI Breadcrumb — einheitlicher Modul-Pfad oberhalb PageHeader.
 *
 * @since v2.484.0
 */
import { NavLink } from 'react-router-dom';

export default function FlowAIBreadcrumb({ trail = [] }) {
  return (
    <div className="flex items-center gap-2 text-sm mb-4">
      <NavLink to="/" className="text-[var(--text-secondary)] hover:text-[var(--text-primary)]">Home</NavLink>
      <span className="text-[var(--text-tertiary)]">/</span>
      <NavLink to="/flowai" className="text-[var(--text-secondary)] hover:text-[var(--text-primary)]">FlowAI</NavLink>
      {trail.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          <span className="text-[var(--text-tertiary)]">/</span>
          {item.to ? (
            <NavLink to={item.to} className="text-[var(--text-secondary)] hover:text-[var(--text-primary)]">{item.label}</NavLink>
          ) : (
            <span className="text-[var(--text-primary)] font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </div>
  );
}
